(() => {
  const focusSearch = () => document.querySelector('#search-drawer-input')?.focus();
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    if (target?.matches('[aria-controls*="search-drawer"]')) requestAnimationFrame(focusSearch);
  });

  // Native HeightObserver updates these root variables when the rotating
  // announcement wraps. Recalculate the open menu's offset without requiring
  // a scroll event, preserving its native layout and opening animation.
  let menuOffsetQueued = false;
  const syncMenuOffsets = () => {
    menuOffsetQueued = false;
    document.querySelectorAll('header-menu-drawer[open]').forEach(drawer => {
      const content = drawer.shadowRoot?.querySelector('[part="content"]');
      if (!content) return;
      const top = content.getBoundingClientRect().top;
      if (!Number.isFinite(top)) return;
      const value = `${top}px`;
      if (drawer.style.getPropertyValue('--menu-offset-top') !== value) {
        drawer.style.setProperty('--menu-offset-top', value);
      }
    });
  };
  const queueMenuOffsets = () => {
    if (menuOffsetQueued) return;
    menuOffsetQueued = true;
    requestAnimationFrame(syncMenuOffsets);
  };
  new MutationObserver(queueMenuOffsets).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['style'],
  });
  document.addEventListener('dialog:after-show', event => {
    if (event.target?.matches('header-menu-drawer')) queueMenuOffsets();
  }, true);
  window.addEventListener('resize', queueMenuOffsets, { passive: true });
  window.addEventListener('pageshow', queueMenuOffsets);
})();
